import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import "./App.css";
import HeroSection from "./components/heroSection/HeroSection.js";
import OfferSection from "./components/offerSection/OfferSection.js";
import FeaturesList from "./components/featuresSection/FeaturesSection.js";
import DownloadButtons from "./components/downloadButtons/DownloadButtons.js";
import Download from "./components/download/Download.js";
import Admin from "./components/Admin.js";

import Footer from "./components/footer/Footer.js";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PrivacyPolicy from "./document/PrivacyPolicy.js";
import TermsofUseGuest from "./document/TermsofUseGuest.js";
import TermsofUseHost from "./document/TermsofUseHost.js";
import ContactUs from "./pages/contactUs/ContactUs.js";
import TermsofUseGeneral from "./document/TermsofUseGeneral.js";
import ContactSection from "./components/contactSection/ContactSection.js";
import ShortletDetails from "./components/shortletDetails/ShortletDetails.js";
import MobileRedirect from "./components/MobileRedirect.js";
import KycForm from "./pages/kycForm/KycForm.js";
import KycFormForHost from "./pages/kycForm/KycFormForHost.js";

import { useAnalytics } from "./hooks/useAnalytics";

export const HomePage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Affordable Shortlet Rentals in Lagos | Book Now</title>
        <meta
          name="description"
          content="Discover affordable shortlet apartments in Lagos, Nigeria. Book vacation homes, luxury rentals, and serviced apartments across Ikeja, Lekki, and Victoria Island."
        />
        <meta
          name="keywords"
          content="shortlet rentals in lagos Nigeria, cheap shortlet rentals in Lagos, short term rentals Lagos, furnished apartments Lagos, Ikeja shortlets, Victoria Island apartments, Lekki rentals, budget shortlets Lagos, Lagos vacation homes, Apartments for rent Lagos, Lagos accommodation"
        />
        <link rel="canonical" href="https://www.booking.nimblecasa.com/" />

        <meta
          property="og:title"
          content="Affordable Shortlet Rentals in Lagos | Book Now"
        />
        <meta
          property="og:description"
          content="Book serviced shortlets and vacation apartments across Lagos including Ikeja, Lekki, and VI."
        />
        <meta property="og:url" content="https://www.booking.nimblecasa.com/" />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://www.booking.nimblecasa.com/og-image.jpg"
        />

        {/* Twitter Meta */}
        {/* <meta name="twitter:card" content="summary_large_image" /> */}
        <meta
          name="twitter:title"
          content="Affordable Shortlet Rentals in Lagos | Book Now"
        />
        <meta
          name="twitter:description"
          content="Find budget and luxury shortlet apartments in Lagos for business and vacation stays."
        />
        <meta
          name="twitter:image"
          content="https://www.booking.nimblecasa.com/og-image.png"
        />
      </Helmet>
      <HeroSection />
      <OfferSection />
      <FeaturesList />
      <DownloadButtons />
    </>
  );
};

function App() {
  useAnalytics();

  return (
    <BrowserRouter>
      <div className="App">
        <Routes>
          <Route
            path="/"
            element={
              <>
                <HomePage />
                <Footer />
              </>
            }
          />

          <Route
            path="/kyc-form"
            element={
              <>
                <KycForm />
                {/* <Footer /> */}
              </>
            }
          />
          <Route
            path="/kyc-form-for-host"
            element={
              <>
                <KycFormForHost />
              </>
            }
          />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-use-guest" element={<TermsofUseGuest />} />
          <Route path="/terms-of-use-host" element={<TermsofUseHost />} />
          <Route path="/terms-of-use-general" element={<TermsofUseGeneral />} />

          <Route path="/redirect" element={<Download />} />
          <Route path="/adDetailsScreen/:id" element={<ShortletDetails />} />
          <Route path="/mobile" element={<MobileRedirect />} />

          <Route path="/contact-us" element={<ContactUs />} />

          <Route path="/admin" element={<Admin />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
